export default __webpack_public_path__ + "static/media/arrow_down.cd6b84d9.svg";